<template>
  <div id="login-form">
    <v-alert
      :icon="false"
      dense
      v-if="errorMessage"
      :color="$appConfig.alert.colors.error"
      class="py-3 mb-6 break-word"
    >
      <template>
        <v-icon :color="$appConfig.alert.colors.errorIcon">
          mdi-alert-circle-outline
        </v-icon>
      </template>
      <span class="text--primary body-2">
        {{ errorMessage }}
      </span>
    </v-alert>

    <div id="login-form__wrapper">
      <v-form
        v-model="isFormValid"
        ref="loginForm"
        @submit.prevent="submitHandler"
      >
        <div class="form-group pb-1">
          <v-text-field
            outlined
            validate-on-blur
            class="required"
            label="Email Address"
            v-model="formData.email"
            :rules="[required('Email address'), validateEmail]"
          />
        </div>
        <div class="form-group">
          <password-input-field
            :password="formData.password"
            :rules="[required('', 'Please enter a password.')]"
            @update-password="formData.password = $event"
          />
        </div>
        <div class="form-group pt-1">
          <v-btn
            block
            large
            type="submit"
            color="primary"
            :loading="isLoading"
            :disabled="!isFormValid"
            class="button font-weight-bold"
          >
            Login
          </v-btn>
        </div>
      </v-form>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { PasswordInputField } from "@/components/shared";
import { required, validateEmail } from "@/validators";
import { AUTH_GIP_ERROR_CODES } from "@/constants";

/**
 * Auth error codes
 */
const authErrorCodes = Object.values(AUTH_GIP_ERROR_CODES);
authErrorCodes.length = 2;
/**
 * Login form
 */
export default {
  name: "LoginForm",
  /**
   * ---------- Components ------------
   */
  components: {
    PasswordInputField,
  },
  /**
   * ---------- Data properties ------------
   */
  data() {
    return {
      isFormValid: false,
      showPassword: false,
      formData: { email: "", password: "" },
      isLoading: false,
      errorMessage: "",
    };
  },
  /**
   * ---------- Computed properties ------------
   */
  computed: {
    ...mapGetters({
      isLoggedIn: "auth/isLoggedIn",
    }),
  },
  /**
   * ---------- Methods ------------
   */
  methods: {
    required,
    validateEmail,
    /**
     * Maps store action
     */
    ...mapActions({ signInUser: "auth/signInUser" }),
    /**
     * Handles login form submittion
     */
    submitHandler() {
      if (!this.isFormValid) {
        return this.$refs.loginForm.validate();
      }
      this.signInUserApi();
    },
    /**
     * Sends a post request to login the user
     */
    async signInUserApi() {
      try {
        this.setIsloading(true);

        await this.signInUser(this.formData);
      } catch (error) {
        const { code, message } = error;

        if (authErrorCodes.includes(code)) {
          this.errorMessage = this.$dictionary.app.loginForm.invalidUserMsg;
        } else {
          this.errorMessage = message;
        }
      } finally {
        this.setIsloading(false);
      }
    },
    /**
     * Sets isloading property to display the loader
     */
    setIsloading() {
      this.isLoading = !this.isLoading;
    },
  },
};
</script>
